import Environments from '@delta-defense/client-environments';
import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import 'regenerator-runtime/runtime';
import 'url-search-params-polyfill';
import FormContainer from './components/FormContainer/FormContainer';
import './index.scss';

const title = document.querySelector('title');
const favicons = document.querySelectorAll<HTMLLinkElement>('link[rel*="icon"]');
const isCabelas = Environments.isCabelasShieldBrand();

if (title && isCabelas) {
  title.innerText = 'Cabela\'s Shield Portal';

  favicons.forEach((favicon) => {
    favicon.href = '/cs-favicon.avif';
  });
}

ReactDOM.render(
  <BrowserRouter>
    <FormContainer />
  </BrowserRouter>,
  document.getElementById('root')
);
